import React from 'react';
import Typography from 'antd/lib/typography';
import { formatFileId } from 'src/domain/customer-utility-bill-file/interface';
import { EMPTY_VALUE } from './billStyles';

const { Text } = Typography;

// Displays the id part of a composite file id, truncated to the column width (full value in tooltip) with a copy button.
export const FileIdCell = ({ fileId }: { fileId: string | null }) => {
    if (!fileId) return <Text type="secondary">{EMPTY_VALUE}</Text>;
    const id = formatFileId(fileId);
    return (
        <Text copyable={{ text: id }} ellipsis={{ tooltip: id }}>
            {id}
        </Text>
    );
};
